import React from 'react';
import T from 'prop-types';

import AppInfo from './AppInfo';
import Container from '../../../../components/Container';

const TopAppsLine = ({ apps, isMobileView }) => (
  <div className="top-apps-line">
    <Container maxWidth={1248}>
      <div className="apps-container">
        {apps.map((app, index) => (
          <AppInfo
            key={index}
            size={isMobileView ? 48 : 64}
            app={app}
            showTicker
            enableTooltip={!isMobileView}
          />
        ))}
      </div>
    </Container>
  </div>
);

TopAppsLine.propTypes = {
  apps: T.arrayOf(
    T.shape({
      icon_url: T.string,
      name: T.string,
      ticker: T.string,
    })
  ).isRequired,
  isMobileView: T.bool.isRequired,
};

export default TopAppsLine;
